import { memo } from 'react';
import Box from '../Box/Box';

function VerticalListSeparator() {
  return <Box width="space-full" height="space-400" />;
}

export default memo(VerticalListSeparator);
